module.exports = __webpack_public_path__ + "img/category-new-released-hover.bbfa4ac0.png";